import React from 'react';

const SectionLabel = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="section-label">
      <span className="h-1.5 w-1.5 bg-white" />
      <span>{children}</span>
    </div>
  );
};

export default SectionLabel;
